import FilterListIcon from "@mui/icons-material/FilterList";
import { MuiGrid } from "../grid/MuiGrid";
import { MuiButtonTertiary } from "../button/MuiButton";
import React, { FC, useEffect, useState } from "react";
import { MuiMenuList } from "../menu/MuiMenuList";
import { MenuListParams } from "../../api/services/client/models";
import { VersionTrackerModalWrapper } from "./MuiVersionTracker.style";
import { useLocation, useNavigate } from "react-router-dom";
import { PAGE_URLS } from "../../helpers/constants";
import { MuiTypography } from "../typography/MuiTypography";
import { useSiteCore } from "../../hooks/useSiteCore";
import { commonSiteCoreKeys } from "../../helpers/constants/siteCoreKeys";
import { isNotEmpty } from "../../helpers/utils";

interface VersionTrackerModalProps {
  history: MenuListParams[];
  isDisabledHistory: boolean;
}

export const VersionTrackerModal: FC<VersionTrackerModalProps> = ({
  history,
  isDisabledHistory,
}) => {
  const [showMenuList, setShowMenuList] = useState(false);
  const anchorRef = React.useRef<HTMLButtonElement>(null);
  const navigate = useNavigate();
  const location = useLocation();

  const { fetchCommonLabel } = useSiteCore();

  useEffect(() => {
    setShowMenuList(false);
  }, [location]);

  const handleVersionLabelClick = () => {
    if (!isDisabledHistory) {
      setShowMenuList(true);
    }
  };

  const handleRowClick = (item: MenuListParams) => {
    handleClose();
    navigate(`${PAGE_URLS.VIEW_PROGRAM}/${item.id}`);
  };

  const handleClose = () => {
    setShowMenuList(false);
  };

  const getVersionName = () => {
    const path = location?.pathname;
    const selectedItem = history?.find(
      (item) => item.id && path?.includes(item.id),
    );
    return selectedItem?.name || fetchCommonLabel(commonSiteCoreKeys.version);
  };

  return (
    <VersionTrackerModalWrapper>
      <MuiGrid size={{ xs: 6 }} className="form-header-right">
        <MuiButtonTertiary
          onClick={handleVersionLabelClick}
          data-testid="version-history-list-button"
          ref={anchorRef}
          disabled={isDisabledHistory}
        >
          <FilterListIcon />
          <MuiTypography className="version-name">
            {getVersionName()}
          </MuiTypography>

          {isNotEmpty(history) && showMenuList && (
            <MuiMenuList
              menuArray={history}
              refValue={anchorRef.current}
              open={showMenuList}
              onClose={handleClose}
              onRowClick={handleRowClick}
              data-testid="version-history-list-item"
            />
          )}
        </MuiButtonTertiary>
      </MuiGrid>
    </VersionTrackerModalWrapper>
  );
};
